import { getEntity } from 'globalFunctions';
import { TFunction } from 'i18next';
import { ApiErrorInfo } from 'models/apiErrorInfo';
import Task, { TaskStateId } from 'models/tasks/task';
import Tasks from 'models/tasks/tasks';
import { getOutlookErrorMsg } from 'services/Api/apiErrors';
import AppError from './appError';
import ControllerException, { ControllerExceptionCodes } from './controllerException';

export const TaskStateColor: Record<TaskStateId, string> = {
  [TaskStateId.Requested]: '#9e44e3',
  [TaskStateId.Accepted]: '#8471BE',
  [TaskStateId.InProgress]: '#7788ac',
  [TaskStateId.Completed]: '#5DB588',
  [TaskStateId.Archived]: '#58c76e',
  [TaskStateId.Rejected]: '#c56379',
  [TaskStateId.OnHold]: '#e2d95d',
};

export const getTaskStateColor = (taskStateId: number): string => {
  return TaskStateColor[taskStateId as TaskStateId] || '#999999';
};

export const getTaskStateForColor = (color: string): number => {
  for (const [stateId, stateColor] of Object.entries(TaskStateColor)) {
    if (stateColor === color) {
      return Number(stateId);
    }
  }

  return 0;
};

export const handleBulkErrors = (updatedTasks: Tasks, allTasks: Task[], t: TFunction<string[]>): ApiErrorInfo[] => {
  const errors: ApiErrorInfo[] = [];

  if (Object.keys(updatedTasks.errorInfo).length > 0) {
    //enrich the error info with task entity info and display message
    for (const taskId in updatedTasks.errorInfo) {
      const error = updatedTasks.errorInfo[taskId];
      const task = allTasks.find((t) => t.taskId.toString() === taskId);
      if (task) {
        error.entity = getEntity(task);
      }
      if (error.controllerExceptionCode) {
        error.displayMessage = ControllerException.getMessage(error.controllerExceptionCode, t, error.message);
      } else {
        const appErr = new AppError(error.message, '400');
        appErr.debug = error.details;
        const outlookError = getOutlookErrorMsg(appErr, t);
        if (outlookError) {
          error.displayMessage = outlookError;
          //set a controller exception code so that no ticket is created
          //this should be improved by letting the back-end return actual ControllerExceptions for Outlook errors
          error.controllerExceptionCode = ControllerExceptionCodes.Code_General_NotAuthorized;
        } else {
          error.displayMessage = error.message || t('exceptions:General.UnknownError');
        }
      }
      errors.push(error);
    }
  }

  return errors;
};
